import { Text, Box } from '@usap/uicomponents'
import styled from 'styled-components'

const darkColor = props => props?.theme?.global?.colors['dark-2']
// eslint-disable-next-line arrow-body-style
const pageWidth = props => {
  return props?.theme?.global?.size?.pageWidth || '1248px'
}
const tabletBreakpoints = props => props?.theme?.mediaQuery?.up('tablet-landscape')

export const BreadCrumbWrapper = styled(Box)`
  width: ${pageWidth};
  margin: 0 auto;
  ${tabletBreakpoints} {
    margin: ${props => props.isNotFound?'0 66px':'0 auto'};
  }
`

export const BreadcrumbsContainer = styled(Box)`
  box-sizing: border-box;
  width: 100%;
  margin: ${props => props.isNotFound?'12px auto':'24px auto 16px'};
  display: flex;
  flex-wrap: wrap;
  padding: 0 16px;

  &.breadCrumbListScrollable{
    overflow-x: scroll;
    white-space: nowrap;
    display: inline-block;
  }
  
  &.breadCrumbListScrollable li{
    display: inline-block;
  }
  
  &.breadCrumbListScrollable::-webkit-scrollbar {
    display: none;
  }

  ${tabletBreakpoints} {
    padding: 0 40px;
  }
`

export const BreadcrumbsTextWithStyle = styled(Text)`
  cursor: ${({ noPointer = false }) => (noPointer ? 'unset' : 'pointer')};
  line-height: 20px;
  color: ${darkColor};
  font-size: 14px;
  font-weight: 400;
`

export const LastLinkTextWithStyle = styled(Text)`
  cursor: ${({ noPointer = false }) => (noPointer ? 'unset' : 'pointer')};
  font-size: 14px;
  line-height: 20px;
  color: ${darkColor};
  font-weight: 600;
  text-align: center;
`

export const Divider = styled(Text)`
  font-size: 14px;
  line-height: 20px;
  color: ${darkColor};
  padding: 0 4px;
`
